import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import PT from 'prop-types';
import { T as TileBox } from './TileBox-Cv7f5ttf.js';

const getPadding = ({
  noPadding
}) => {
  switch (true) {
    case noPadding === true:
      {
        return 'none';
      }
    default:
      {
        return 'medium';
      }
  }
};
const TileSection = ({
  children,
  noPadding,
  paddingBlockStart,
  paddingBlockEnd,
  paddingInlineStart,
  paddingInlineEnd,
  ...restProps
}) => {
  const padding = getPadding({
    noPadding
  });
  return /*#__PURE__*/React__default.createElement(TileBox, _extends({}, restProps, {
    hideStartBorder: false,
    paddingBlockStart: paddingBlockStart !== null && paddingBlockStart !== void 0 ? paddingBlockStart : padding,
    paddingBlockEnd: paddingBlockEnd !== null && paddingBlockEnd !== void 0 ? paddingBlockEnd : padding,
    paddingInlineStart: paddingInlineStart !== null && paddingInlineStart !== void 0 ? paddingInlineStart : padding,
    paddingInlineEnd: paddingInlineEnd !== null && paddingInlineEnd !== void 0 ? paddingInlineEnd : padding
  }), children);
};
TileSection.defaultProps = {
  noPadding: false
};
TileSection.propTypes = {
  /**
   * Content of the TileSection.
   */
  children: PT.node.isRequired,
  /**
   * Specifies whether the container has padding or not
   */
  noPadding: PT.bool
};

export { TileSection as T };
//# sourceMappingURL=TileSection-CLQQKazp.js.map
